module.exports = __webpack_public_path__ + "img/download-tp-prod-backup.1cdd238c.png";